import React, { useState } from 'react';
import AdminFormattedMessages from '../../messages/admin/AdminFormattedMessages';
import Layout from '../../components/layouts/Layout';
import { Divider, Stack, Typography, Tabs, Tab, Box } from '@mui/material';
import { AdminRoutes } from '../../routes/AdminRoutes';
import Issues from '../../components/admin/compliance/Issues';
import Trial from '../../components/admin/compliance/Trial';
import Regular from '../../components/admin/compliance/Regular';

const CompliancePage = (props) => {
  const { accessLevel, accessType } = props;

  const [tab, setTab] = useState('Issues');
  return (
    <Layout
      title={AdminFormattedMessages.compliance}
      routes={AdminRoutes}
      accessLevel={accessLevel}
      accessType={accessType}
    >
      <Stack gap={2}>
        <Box sx={{ borderBottom: 2, borderColor: 'divider' }}>
          <Tabs
            value={tab}
            onChange={(_, newValue) => {
              setTab(newValue);
            }}
            aria-label="compliance tabs"
          >
            <Tab label="Issues" value="Issues" sx={{ paddingTop: 0.5 }} />
            <Tab label="Trial" value="Trial" sx={{ paddingTop: 0.5 }} />
            <Tab label="All" value="All" sx={{ paddingTop: 0.5 }} />
          </Tabs>
        </Box>
        <Box>
          {tab === 'Issues' && (
            <Issues
              navigate={props.navigate}
              errorHandler={props.errorHandler}
            />
          )}
          {tab === 'Trial' && (
            <Trial
              navigate={props.navigate}
              errorHandler={props.errorHandler}
            />
          )}
          {tab === 'All' && (
            <Regular
              navigate={props.navigate}
              errorHandler={props.errorHandler}
            />
          )}
        </Box>
      </Stack>
    </Layout>
  );
};

export default CompliancePage;
